export const SAMPLE_TEST_MARKER = "sample_test_agilysys";

export const isSampleTestRow = (row: Record<string, unknown>): boolean =>
  Object.values(row).some((value) => {
    if (typeof value === "string") {
      return value.toLowerCase().includes(SAMPLE_TEST_MARKER);
    }
    if (Array.isArray(value)) {
      return value.some(
        (item) =>
          typeof item === "string" &&
          item.toLowerCase().includes(SAMPLE_TEST_MARKER),
      );
    }
    return false;
  });

/** Strip demo/sample rows from list payload sections before Excel export or import. */
export const removeSampleTestFromPayload = <T extends Record<string, unknown>>(
  data: T,
): T => {
  const result = { ...data } as Record<string, unknown>;

  Object.keys(result).forEach((key) => {
    if (Array.isArray(result[key])) {
      result[key] = (result[key] as Record<string, unknown>[]).filter(
        (row) => !isSampleTestRow(row),
      );
    }
  });

  return result as T;
};
